import { zetApi } from '@zet/network'

import { IFetchTier } from '../types'

export async function fetchTier() {
  const { data } = await zetApi.get<IFetchTier>(`/loyalty/getTier`)
  return data.data
}
